export class Portfolio {
    wrapper = $( '#portfolio-wrapper' );
    tile = $( '#portfolio-wrapper .portfolio.__tile' );
    modal = $( '#modal .modal.__wrapper' );
    loadMore = $( '#load-more-posts' );

    constructor() {
        if ( !this.wrapper.length ) {
            return;
        }

        this.addEvents();
        this.modalEvents();
    }

    addEvents() {
        $( document ).on( 'click', '.portfolio.__tile', tile => {
            const id = parseInt( tile.currentTarget.dataset.id );
            if ( id ) {
                this.modal.show();
                $( 'body' ).addClass( 'modal-open' );

                $.ajax( {
                    type: 'GET',
                    url: '/api/posts/single/' + id,
                    headers: {
                        'X-CSRF-TOKEN': $( 'meta[name="csrf-token"]' ).attr( 'content' )
                    },
                    contentType: false,
                    processData: false,
                    cache: false,
                    success: result => {
                        const iframe = JSON.parse( result.attributes ).iframe;
                        setTimeout( () => $( '#modal .modal.__inner' ).html( iframe ), 500 );
                    },
                    error: response => {
                        alert( 'Problem z załadowaniem filmu...' );
                    }
                } );
            }
        } );

        this.loadMore.click( load => {
            const page = parseInt( load.currentTarget.dataset.page );
            if ( page ) {
                $( '#load-more-posts .loading-wrapper' ).show();
                $( '#load-more-posts .view-more-trigger' ).hide();

                $.ajax( {
                    type: 'GET',
                    url: '/api/posts/get?page=' + page,
                    headers: {
                        'X-CSRF-TOKEN': $( 'meta[name="csrf-token"]' ).attr( 'content' )
                    },
                    contentType: false,
                    processData: false,
                    cache: false,
                    success: result => {
                        if ( result ) {
                            const grid = document.createElement( 'div' );
                            if ( result.length === 12 ) {
                                grid.className = '[ portfolio __grid ]';
                            } else {
                                grid.className = '[ portfolio __grid --g' + result.length + ' ]';
                            }
                            let i = 1;

                            result.forEach( item => {
                                const tile = document.createElement( 'div' );
                                tile.className = '[ portfolio __tile ]';
                                tile.style.gridArea = 'p' + i;
                                tile.dataset.id = item.id;

                                const img = document.createElement( 'img' );
                                img.src = 'uploads/posts/pl/' + item.slug + '/main/' + item.image;
                                img.className = 'img-fluid';
                                img.setAttribute( 'alt', '' );

                                const text = document.createElement( 'div' );
                                text.className = 'tile-text';

                                const heading = document.createElement( 'h3' );
                                heading.innerHTML = item.title;

                                const info = document.createElement( 'div' );
                                info.className = 'info';
                                info.innerHTML = '<span>view more</span> | <span>click</span>';

                                text.appendChild( heading );
                                text.appendChild( info );

                                tile.appendChild( img );
                                tile.appendChild( text );

                                grid.appendChild( tile );
                                i = i + 1;
                            } );

                            setTimeout( () => {
                                $( '#load-more-posts .loading-wrapper' ).hide();
                                $( '#load-more-posts .view-more-trigger' ).show();
                                document.getElementById( 'portfolio-wrapper' ).appendChild( grid );
                                this.loadMore[ 0 ].dataset.page = page + 1;
                            }, 1000 );

                        }
                    },
                    error: response => {
                        $.notify( {
                            title: ' ',
                            message: 'Error'
                        }, {
                            type: 'danger'
                        } );
                    }
                } );
            }
        } );
    }

    modalEvents() {
        if ( !this.modal.length ) {
            return;
        }

        $( '#modal .modal.__close' ).click( () => {
            this.modal.hide();
            $( '#modal .modal.__inner' ).html( '' );
            $( 'body' ).removeClass( 'modal-open' );
        } );

    }
}
